// let jQuery = window.$;

import { Tooltip, Toast, Popover, Carousel, Tab } from 'bootstrap';
let Flickity = require('flickity');
let Masonry = require('masonry-layout');
let imagesLoaded = require('imagesloaded');

console.log('app.js loaded');

(function ($, Drupal, drupalSettings) {

  [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
  });

  [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl);
  });

  [].slice.call(document.querySelectorAll('.toast')).map(function (toastEl) {
    return new Toast(toastEl);
  });

  // Check DOMs
  if (document.readyState === "complete") {
    // Fully loaded!
    console.log('Loaded');
    resizeHeaderSpacing();
  }
  else if (document.readyState === "interactive") {
    // DOM ready! Images, frames, and other subresources are still downloading.
    console.log('Loading...');
    resizeHeaderSpacing();
  }
  else {
    // Loading still in progress.
    // To wait for it to complete, add "DOMContentLoaded" or "load" listeners.

    window.addEventListener("DOMContentLoaded", () => {
      // DOM ready! Images, frames, and other subresources are still downloading.
      var closeButton = document.querySelector('.notice-btn-close');
      if (closeButton) {
        closeButton.addEventListener('click', resizeHeaderSpacing);
      }
      resizeHeaderSpacing();
      // apply only to homepage
      if (window.location.pathname == '/' || window.location.pathname == '/home') {
        fadeHomeLogo();
      }
    });

    window.addEventListener("load", () => {
      // Fully loaded!
      // var popupText = Drupal.settings.popup_text;

      $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
          $('#scroll-to-top').fadeIn();
        } else {
          $('#scroll-to-top').fadeOut();
        }
      });

      // Scroll to top when the button is clicked
      $('#scroll-to-top').click(function (event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 400);
      });

      let ackno = 'loaded';
      // fadeHomeLogo(ackno);

      //Grab title for image rollover
      $(".rollover").each(function () {
        let imageTitle = $(this).find('img').attr("title");

        // Only set img-data if it is currently empty
        if (!$(this).attr('img-data')) {
          $(this).attr('img-data', imageTitle);
        }
      });
      // const video = document.getElementById('video-hero');
      // const muteButton = document.getElementById('unmute')

      // if (muteButton) {
      //   muteButton.addEventListener('click', () => {
      //     if (video.muted) {
      //       video.muted = false;
      //       muteButton.innerHTML = '<i class="fas fa-volume-up"></i>';
      //     } else {
      //       video.muted = true;
      //       muteButton.innerHTML = '<i class="fas fa-volume-mute"></i>';
      //     }
      //   });
      // }

      // changed the below to banner area ready rather than document ready
      // so that users can pause as soon as the banner area is loaded
      // rather than waiting for the entire dom to load before being able to pause
      // at least in theory anyway - still seems to be a short unpausable period of play
      // maybe need to load the video paused, then only play on '.banner-area' ready
      $('.banner-area').ready(function () {
        var video = $('#video-hero')[0];
        var unmuteButton = $('#unmute');
        var playButton = $('.video-button');
        // playButton.hide();
        var mouse_timeout = null;

        function resetTimer() {
          clearTimeout(mouse_timeout);
          if (playButton.is(":hidden")) playButton.show();
          mouse_timeout = setTimeout(function () {
            playButton.fadeOut();
          }, 2000);
        }

        $('.banner-area').on('mousemove', function () {
          resetTimer();
        });

        $('#video-hero').click(function () {
          if (video) {
            resetTimer();
            if (video.paused) {
              video.play();
              $('.pause-button').removeClass('d-none');
              $('.play-button').addClass('d-none');
            } else {
              video.pause();
              $('.pause-button').addClass('d-none');
              $('.play-button').removeClass('d-none');
            }
          }
        });

        $('.video-button').click(function () {
          if (video) {
            resetTimer();
            if (video.paused) {
              video.play();
              $('.pause-button').removeClass('d-none');
              $('.play-button').addClass('d-none');
            } else {
              video.pause();
              $('.pause-button').addClass('d-none');
              $('.play-button').removeClass('d-none');
            }
          }
        });

        // hack to trigger a click on page load
        // because for some reason it doesnt detect mouse movement until it's been clicked
        // but this pauses it
        // so trigger a second click to make it play
        $('#video-hero').click();
        $('#video-hero').click();

        // commenting this out because otherwise clicking on the play/pause icon double activates
        // it would count one click for the video area and one click for the icon
        // playButton.click(function() {
        //     if (video.paused) {
        //         video.play();
        //         playButton.html('<i class="fas fa-pause"></i>');
        //     } else {
        //         video.pause();
        //         playButton.html('<i class="fas fa-play"></i>');
        //     }
        // });

        //   function togglePlayPause() {
        //     if (video.paused) {
        //         video.play();
        //         playButton.html('<i class="fas fa-pause"></i>');
        //     } else {
        //         video.pause();
        //         playButton.html('<i class="fas fa-play"></i>');
        //     }
        // }

        // playButton.click(togglePlayPause);
        // video.click(togglePlayPause);

        unmuteButton.click(function () {
          if (video) {
            if (video.muted) {
              video.muted = false;
              unmuteButton.html('<i class="fas fa-volume-up"></i>');
            } else {
              video.muted = true;
              unmuteButton.html('<i class="fas fa-volume-mute"></i>');
            }
          }
        });

        // idk what any of the below is

        // $('#video-hero').each(function (index, element) {
        //   let isplaying = true;

        //   $('.banner-area').hover(
        //     function () {
        //       if (video) {
        //         if (
        //           video.play &&
        //           $('.banner-area').find('.pause-button').hasClass('d-none')
        //         ) {
        //           $('.banner-area').find('.pause-button').toggleClass('d-none');
        //         }
        //       }
        //     },
        //     function () {
        //       if (video) {
        //         if (video.play) {
        //           $('.banner-area').find('.pause-button').toggleClass('d-none');
        //         }
        //       }
        //     }
        //   );

        //   $(element)
        //     .find('.play-button')
        //     .click(function () {
        //       $(element).find('video').trigger('play');
        //       isplaying = true;
        //       $(element).find('.play-button').toggleClass('d-none');
        //       $(element).find('.pause-button').toggleClass('d-none');
        //     });

        //   $(element)
        //     .find('.pause-button')
        //     .click(function () {
        //       $(element).find('video').trigger('pause');
        //       isplaying = false;
        //       $(element).find('.play-button').toggleClass('d-none');
        //       $(element).find('.pause-button').toggleClass('d-none');
        //     });
        // });

      });
    });
  }

  // Sticky Header
  // When the user scrolls the page, execute myFunction
  window.onscroll = function () { myFunction() };

  // Get the header
  let header = document.getElementById("mainheader");

  // Get the offset position of the navbar
  let sticky = header.offsetTop;

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function myFunction() {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }

  // Show tab on hover
  $(".nav-link").hover(function () {
    $(this).tab('show');
  });

  //Display search bar on click
  $(".search-btn").click(function () {
    $('.navbar-buttons a').attr('style', 'display:none !important;');
    $('.search-wrapper').attr('style', 'opacity:1; pointer-events:initial;');
    $('.search-wrapper input[type="text"]').focus();

    $(document).click(function (event) {
      var target = event.target;
      if (
        !$(target).is('.search-btn') &&
        !$(target).is('.navbar-buttons a') &&
        !$(target).is('.search-wrapper') &&
        !$(target).closest('.navbar-buttons').length &&
        !$(target).closest('.search-wrapper').length
      ) {
        $('.navbar-buttons a').attr('style', '');
        $('.search-wrapper').attr('style', '');
      }
    });
  });

  //TODO refactor below carousel stuff (there are 3 which we can probably make DRY)
  //TODO tbh probably requires a bit of rewriting anyway
  const carousels = document.querySelectorAll('.carousel-exhibitions');

  carousels.forEach((carousel, index) => {
    let exhibit = new Flickity(carousel, {
      // Flickity options
      contain: true,
      groupCells: true,
      pageDots: false,
    });

    // function to toggle button clickability based on number of items in carousel
    function toggleButtons() {
      // const lastIndex = exhibit.cells.length - 1;
      const isMobile = window.innerWidth <= 768; // Adjust the breakpoint if needed
      if (exhibit.cells.length <= 2 && !isMobile) {
        $(carousel).find(".next, .previous").attr("disabled", true);
      } else {
        $(carousel).find(".next, .previous").attr("disabled", false);
      }
    }

    // check every settle event to control disable of next button
    exhibit.on('settle', function (index) {
      toggleButtons();
    });
    // check every select event to control disable of next button
    exhibit.on('select', function (index) {
      toggleButtons();
    });
    // initialize buttons on load
    toggleButtons();
  });

  // Add a listener for window resize to handle changes in responsiveness
  window.addEventListener('resize', function () {
    carousels.forEach((carousel) => {
      //toggleButtons(); //TODO this was commented out because toggleButtons is not defined in this scope
    });
  });

  const carousels_room = document.querySelectorAll('.carousel-room');

  carousels_room.forEach((carousels_room, index) => {
    let room = new Flickity(carousels_room, {
      // Flickity options
      contain: true,
      groupCells: true,
      pageDots: false,
    });

    // function to toggle button clickability based on number of items in carousel
    function toggleButtons() {
      // const lastIndex = exhibit.cells.length - 1;
      const isMobile = window.innerWidth <= 768; // Adjust the breakpoint if needed
      if (room.cells.length <= 2 && !isMobile) {
        $(carousels_room).find(".next, .previous").attr("disabled", true);
      } else {
        $(carousels_room).find(".next, .previous").attr("disabled", false);
      }
    }

    // check every settle event to control disable of next button
    room.on('settle', function (index) {
      toggleButtons();
    });
    // check every select event to control disable of next button
    room.on('select', function (index) {
      toggleButtons();
    });
    // initialize buttons on load
    toggleButtons();
  });

  // Add a listener for window resize to handle changes in responsiveness
  window.addEventListener('resize', function () {
    carousels.forEach((carousel) => {
      //toggleButtons(); //TODO this was commented out because toggleButtons is not defined in this scope
    });
  });

  const carousels_explore_home = document.querySelectorAll('.carousel-home-explore-mobile');

  carousels_explore_home.forEach((carousel, index) => {
    let exhibit = new Flickity(carousel, {
      // Flickity options
      contain: true,
      groupCells: true,
      pageDots: false,
    });

    // function to toggle button clickability based on number of items in carousel
    function toggleButtons() {
      const lastIndex = exhibit.cells.length - 1;
      if (exhibit.selectedIndex === lastIndex) {
        $(carousel).find(".next").attr("disabled", true);
      } else {
        $(carousel).find(".next").attr("disabled", false);
      }
      if (exhibit.selectedIndex === 0) {
        $(carousel).find(".previous").attr("disabled", true);
      } else {
        $(carousel).find(".previous").attr("disabled", false);
      }

    }

    // check every settle event to control disable of next button
    exhibit.on('settle', function (index) {
      toggleButtons();
    });
    // check every select event to control disable of next button
    exhibit.on('select', function (index) {
      toggleButtons();
    });
    // initialize buttons on load
    toggleButtons();
  });

  // Get all carousel elements
  var carousels_home = document.querySelectorAll('.carousel-wrapper');

  // Create a ResizeObserver instance
  var resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var carousel = entry.target;
      var image = carousel.querySelector('.carousel-cell img');
      var button = carousel.querySelector('.flickity-button');

      if (!image || !button) {
        return; // Skip this carousel if no image or button is found
      }

      // Create a new Image object
      var img = new Image();

      // Set the source of the Image object to the image source
      img.src = image.src;

      // When the Image object loads, calculate the rendered height and set the position style
      img.onload = function () {
        var computedStyle = getComputedStyle(image);
        var imageHeight = parseInt(computedStyle.height);
        var buttonHeight = parseInt(getComputedStyle(button).height) / 2;
        var prevNextButtons = carousel.querySelectorAll('.flickity-prev-next-button');
        // Loop through each prev/next button element within the current carousel
        prevNextButtons.forEach(function (button) {
          button.style.top = ((imageHeight + buttonHeight) / 2) + 'px';
        });
      };
    });
  });

  // Observe each carousel element
  carousels_home.forEach(function (carousel) {
    resizeObserver.observe(carousel);
  });

  // TODO "protrait"...
  // const carousels_protrait = document.querySelectorAll('.carousel-protrait');

  // carousels_protrait.forEach((carousel, index) => {
  //   let exhibit = new Flickity(carousel, {
  //     // Flickity options
  //     contain: true,
  //     groupCells: true,
  //     pageDots: false,
  //   });

  //   // function to toggle button clickability based on number of items in carousel
  //   function toggleButtons() {
  //     // const lastIndex = exhibit.cells.length - 1;
  //     const isMobile = window.innerWidth <= 768; // Adjust the breakpoint if needed
  //     if (exhibit.cells.length <= 2 && !isMobile) {
  //       $(carousel).find(".next, .previous").attr("disabled", true);
  //     } else {
  //       $(carousel).find(".next, .previous").attr("disabled", false);
  //     }
  //   }

  //   // check every settle event to control disable of next button
  //   exhibit.on('settle', function (index) {
  //     toggleButtons();
  //   });
  //   // check every select event to control disable of next button
  //   exhibit.on('select', function (index) {
  //     toggleButtons();
  //   });
  //   // initialize buttons on load
  //   toggleButtons();
  // });

  // // Add a listener for window resize to handle changes in responsiveness
  // window.addEventListener('resize', function () {
  //   carousels_protrait.forEach((carousel) => {
  //     //toggleButtons(); //TODO this was commented out because toggleButtons is not defined in this scope
  //   });
  // });


  document.addEventListener("DOMContentLoaded", function () {
    const carouselsPortrait = document.querySelectorAll('.carousel-protrait');

    carouselsPortrait.forEach((carousel) => {
        const images = carousel.querySelectorAll("img");
        let imagesLoaded = 0;

        // Check if all images are loaded
        images.forEach(img => {
            if (img.complete) {
                imagesLoaded++;
                if (imagesLoaded === images.length) {
                    initializeSlider(carousel);
                }
            } else {
                img.addEventListener("load", () => {
                    imagesLoaded++;
                    if (imagesLoaded === images.length) {
                        initializeSlider(carousel);
                    }
                });
            }
        });
    });

    function initializeSlider(carousel) {
        const exhibit = new Flickity(carousel, {
            contain: true,
            groupCells: true,
            pageDots: false,
        });

        // Toggle button clickability based on number of items
        function toggleButtons() {
            const isMobile = window.innerWidth <= 768; // Adjust the breakpoint if needed
            if (exhibit.cells.length <= 2 && !isMobile) {
                carousel.querySelectorAll(".next, .previous").forEach(button => {
                    button.setAttribute("disabled", true);
                });
            } else {
                carousel.querySelectorAll(".next, .previous").forEach(button => {
                    button.removeAttribute("disabled");
                });
            }
        }

        exhibit.on('settle', toggleButtons);
        exhibit.on('select', toggleButtons);
        toggleButtons();

        // Adjust slider on window resize
        window.addEventListener('resize', toggleButtons);
    }
});

//for search
  var carousels_home = document.querySelectorAll('.search-carousel-wrapper');

  // Create a ResizeObserver instance
  var resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var carousel = entry.target;
      var image = carousel.querySelector('.carousel-cell img');
      var button = carousel.querySelector('.flickity-button');

      if (!image || !button) {
        return; // Skip this carousel if no image or button is found
      }

      // Create a new Image object
      var img = new Image();

      // Set the source of the Image object to the image source
      img.src = image.src;

      // When the Image object loads, calculate the rendered height and set the position style
      img.onload = function () {
        var computedStyle = getComputedStyle(image);
        var imageHeight = parseInt(computedStyle.height);
        var buttonHeight = parseInt(getComputedStyle(button).height) / 2;
        var prevNextButtons = carousel.querySelectorAll('.flickity-prev-next-button');
        // Loop through each prev/next button element within the current carousel
        prevNextButtons.forEach(function (button) {
          button.style.top = ((imageHeight + buttonHeight) / 2) + 'px';
        });
      };
    });
  });

  // Observe each carousel element
  carousels_home.forEach(function (carousel) {
    resizeObserver.observe(carousel);
  });

  //TODO can we delete the commented out stuff below? what is it?
  // // Get all the slider containers
  // var sliderContainers = document.querySelectorAll('.carousel-wrapper');

  // // Loop through each slider container
  // sliderContainers.forEach(function(container) {
  //   // Get the image element within the current slider container
  //   var image = container.querySelector('.carousel-cell img');

  //   if (image) {} else return;

  //   // Create a new Image object
  //   var img = new Image();

  //   // Set the source of the Image object to the image source
  //   img.src = image.src;

  //   // When the Image object loads, calculate the rendered height and set the position style
  //   img.onload = function() {
  //     var computedStyle = getComputedStyle(image);
  //     var imageHeight = parseInt(computedStyle.height) + 40;
  //     var prevNextButtons = container.querySelectorAll('.flickity-prev-next-button');

  //     // Loop through each prev/next button element within the current slider container
  //     prevNextButtons.forEach(function(button) {
  //       button.style.top = 'calc(' + imageHeight + 'px / 2)';
  //     });
  //   };
  // });

  // check whether the given carousel cell is already in fully view(left and right)
  function isInViewWindowWid(el) {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;

    const {
      top,
      left,
      bottom,
      right
    } = el.getBoundingClientRect();

    return left >= 0 && right <= viewWidth;
  }

  document.addEventListener("DOMContentLoaded", function () {
    let quotes = document.getElementsByClassName('quote');

    if (quotes.length > 0) {
      let isIntersecting = false;
      let observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              isIntersecting = true;
              $(entry.target).find('.p-text').addClass('active');
            } else {
              isIntersecting = false;
              $(entry.target).find('.p-text').removeClass('active');
            }
          });
        },
        { threshold: 1 }
      );

      Array.from(quotes).forEach((quote) => {
        observer.observe(quote);
      });

      window.addEventListener('scroll', function () {
        if (!isIntersecting) {
          let scrollPosition = window.pageYOffset;
          Array.from(quotes).forEach((quote) => {
            if (scrollPosition > quote.offsetTop) {
              $(quote).find('.p-text').addClass('active');
              isIntersecting = true;
            }
          });
        }
      });
    }

    $(".view-media-releases > .row > .accordion-wrap > .accordion > .accordion-item > .accordion-collapse").attr("class", "show");
    // $("#pills-tabContent > .tab-pane > .tab-caption").innerWidth($("#pills-tab").width());
  });

  // Stuff for realigning H1s due to leading pixels on the font
  let h1s = $("main h1");

  h1s.each(function () {
    realignH1s($(this));
  });

  function realignH1s(h1) {
    var charShiftPixels = {
      'A': 1,
      'B': 4,
      'C': 4,
      'D': 4,
      'E': 4,
      'F': 4,
      'G': 4,
      'H': 4,
      'I': 5,
      'J': 1,
      'K': 4,
      'L': 4,
      'M': 4,
      'N': 4,
      'O': 4,
      'P': 4,
      'Q': 3,
      'R': 4,
      'S': 2,
      'T': 1,
      'U': 4,
      'V': 1,
      'W': 1,
      'X': 0,
      'Y': 0,
      'Z': 2,
      '1': 1,
      '2': 2,
      '3': 3,
      '4': 2,
      '5': 3,
      '6': 3,
      '7': 1,
      '8': 3,
      '9': 3,
      '0': 4
    };
    let firstChar = h1.text().trim().charAt(0).toUpperCase(); //TODO there may be cases where h1 starts with a lowercase letter...
    h1.css("margin-left", "-=" + charShiftPixels[firstChar] + "px");
  }

  // masonry stuff
  $(document).ready(function () {
    let elem = document.querySelector('.grid');
    let msnry = new Masonry(elem, {
      // options
      itemSelector: '.grid-item',
      percentPosition: true,
      columnWidth: '.grid-sizer',
      isAnimated: true,
    });

    imagesLoaded(elem, function () {
      // Set a random height for each item (between 400px and 700px)
      $('.grid-item').each(function () {
        let itemHeight = Math.floor(Math.random() * 300) + 400; // generate a random number between 400 and 700
        $(this).css('height', itemHeight + 'px');
      });

      msnry = new Masonry(elem, {
        // options
        itemSelector: '.grid-item',
      });
    });
  });

  //button control for videos in democracy page
  // check whether the element is fully in the visible area of browser
  function isInViewWindow(el) {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;

    const {
      top,
      left,
      bottom,
      right
    } = el.getBoundingClientRect();

    return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
  }

  // autoplay the video when it is fully in the visible area of browser
  if ($('.video-module').length > 0) {
    $(window).scroll(function () {
      $('.video-module').each(function (index, element) {
        if ($(element).find('.play-button').hasClass('d-none')) {
          if (isInViewWindow(element)) {
            $(element).find('video').trigger('play');
          } else {
            $(element).find('video').trigger('pause');
          }
        }
      });
    });

    $('.video-module').each(function (index, element) {
      let isplaying = true;

      $(element).hover(
        function () {
          if (
            isplaying &&
            $(element).find('.pause-button').hasClass('d-none')
          ) {
            $(element).find('.pause-button').toggleClass('d-none');
          }
        },
        function () {
          if (isplaying) {
            $(element).find('.pause-button').toggleClass('d-none');
          }
        }
      );

      $(element)
        .find('.play-button')
        .click(function () {
          $(element).find('video').trigger('play');
          isplaying = true;
          $(element).find('.play-button').toggleClass('d-none');
          $(element).find('.pause-button').toggleClass('d-none');
        });

      $(element)
        .find('.pause-button')
        .click(function () {
          $(element).find('video').trigger('pause');
          isplaying = false;
          $(element).find('.play-button').toggleClass('d-none');
          $(element).find('.pause-button').toggleClass('d-none');
        });
    });
  }

  let video_about = document.getElementById('video-about');
  let is_manually_paused = false;

  $('#video-about-section').click(() => {
    is_manually_paused = !is_manually_paused;
  })

  if (video_about) {
    $(window).scroll(() => {
      if (isInViewWindow(video_about)) {
        $('#video-about').trigger('play');
      } else {
        $('#video-about').trigger('pause');
      }
    })
  }

  // js for filter in stories page
  let lis = $('.stories-filter li');
  let select = -1;

  $('.stories-filter li').click(function () {
    if (select === -1) {
      select = $(this).index();
      lis[select].classList.toggle('bg-red');
    } else {
      lis[select].classList.toggle('bg-red');
      select = $(this).index();
      lis[select].classList.toggle('bg-red');
    }
  })

  // js for automatically play youtube videos
  // let videos = document.querySelectorAll(".you-video");
  // if (videos) {
  //   $(window).on('scroll', () => {
  //     videos.forEach(video => {
  //       if (isInViewWindow(video)) {
  //         video.contentWindow.postMessage('{"event":"command", "func":"playVideo", "args":""}', '*');
  //       } else {
  //         video.contentWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', '*');
  //       }
  //     });
  //   })
  // }

  // Reattach placeholders for custom block form
  $('.custom-contact-form input[name="name"]').attr('placeholder', 'Your name');
  $('.custom-contact-form input[name="mail"]').attr('placeholder', 'Your email');
  $('.custom-contact-form textarea').attr('placeholder', 'Your message');
  if (drupalSettings.ackno_img_file_url) {
    var ackno_img_file_url = drupalSettings.ackno_img_file_url;
  }
  if (drupalSettings.ackno_img_alt) {
    var ackno_img_alt = drupalSettings.ackno_img_alt;
  }
  if (drupalSettings.ackno_img_credit) {
    var ackno_img_credit = drupalSettings.ackno_img_credit;
  } else {
    var ackno_img_credit = '';
  }
  if (drupalSettings.ackno_credit_descriptor) {
    if (drupalSettings.ackno_credit_descriptor[0]) {
      var ackno_credit_descriptor = drupalSettings.ackno_credit_descriptor[0].value;
    } else {
      var ackno_credit_descriptor = '';
    }
  } else {
    var ackno_credit_descriptor = '';
  }
  if (drupalSettings.ackno_text) {
    if (drupalSettings.ackno_text[0]) {
      var data = drupalSettings.ackno_text[0].value;
    } else {
      var data = '';
    }
  } else {
    var data = '';
  }

  if ($('.field--name-field-opening-hours').hasClass('field--name-field-opening-hours')) {
    $('.field--name-field-opening-hours').addClass('bigger')
  }

  if ($('.field--name-field-o').hasClass('field--name-field-o')) {
    $('.field--name-field-o').addClass('bigger')
  }

  // var popupText = drupalSettings.popup_text.test;

  // check if displayed condition exists popupDisplayed

  // remove filter input from being displayed
  $("#views-exposed-form-search-results-block-2").hide();
  $("#views-exposed-form-search-results-block-3").hide();
  $("#views-exposed-form-search-results-block-4").hide();
  $("#views-exposed-form-search-results-block-5").hide();
  $("#views-exposed-form-show-all-block-1").hide();

  if (sessionStorage.getItem('popupDisplayed')) { // uncomment this line and comment the line below
    // if (sessionStorage.getItem('')) { // pass popupDisplayed into getItem once you done debug and delete this comment
    return;
  }

  function resizeHeaderSpacing() {
    // let mainHeader = $("#mainheader");
    let mainHeader = document.getElementById('mainheader');
    // let mainContent = $("#maincontent");
    let mainContent = document.getElementById('maincontent');
    // mainContent.css("margin-top", mainHeader.innerHeight());
    if (mainContent && mainHeader) {
      mainContent.style.marginTop = window.getComputedStyle(mainHeader, null).getPropertyValue("height");
    }
  }

  resizeHeaderSpacing();

  // Responsive header spacing
  window.addEventListener('resize', function (event) {
    resizeHeaderSpacing();
  }, true);

  // for fading out the moad logo on the homepage
  // should only be called on the homepage
  function fadeHomeLogo() {
    const logo = document.getElementById('home-logo');
    if (getCookie('popupDisplayed') === 'loaded') {
      if (logo) {
        setTimeout(() => {
          if (!logo.classList.contains('hilang')) {
            logo.classList.add('hilang');
          }
        }, 4000);

        window.addEventListener('scroll', () => {
          if (!logo.classList.contains('hilang')) {
            logo.classList.add('hilang');
          }
        }, { once: true });
      }

      return;
    }
  }


  // apply only to homepage

// Run fadeHomeLogo only on home page
if (window.location.pathname === '/' || window.location.pathname === '/home') {
  fadeHomeLogo();
}

// Ackno popup code runs on every page
var popupDisplayed = getCookie('popupDisplayed');
if (!popupDisplayed || popupDisplayed !== 'loaded') {
  // Create backdrop element
  var backdrop = document.createElement('div');
  backdrop.id = 'ackno-popup-backdrop';

  // Create popup element with content
  var popup = document.createElement('div');
  popup.id = 'ackno-popup';
  popup.innerHTML = '<div id="ackno"><div class="ackno-wrapper bg-stone text-dark"><div class="ackno-details"><p class="mb-0 text-start lead-small">' + data + '</p></div><div class="ackno-btn"><h4>Continue</h4><button class="btn-play btn-rounded-outline btn-acknowledge"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="34" viewBox="0 0 19 34" fill="none"><rect y="32.4707" width="23.6231" height="2" transform="rotate(-45 0 32.4707)" fill="black"></rect><rect y="32.4707" width="23.6231" height="2" transform="rotate(-45 0 32.4707)" stroke="black"></rect><rect x="1.41406" y="0.5" width="23.6163" height="2" transform="rotate(45 1.41406 0.5)" fill="black"></rect><rect x="1.41406" y="0.5" width="23.6163" height="2" transform="rotate(45 1.41406 0.5)" stroke="black"></rect></svg></button></div></div></div>';

  // Append backdrop and popup to the body
  var body = document.getElementsByTagName('body')[0];
  body.appendChild(backdrop);
  body.appendChild(popup);

  // Add event listeners to remove the popup and set the cookie when clicked
  $("#ackno-popup-backdrop, .btn-acknowledge").on("click", function () {
    $("#ackno-popup-backdrop").remove();
    $("#ackno-popup").remove();
    setCookie('popupDisplayed', 'loaded');
    setCookie('ackno-popup-backdrop', 'removed'); // Save backdrop removal state

    // If on home page, call fadeHomeLogo after popup removal
    if (window.location.pathname === '/' || window.location.pathname === '/home') {
      fadeHomeLogo();
    }
  });
}

function fadeHomeLogo() {
  const logo = document.getElementById('home-logo');
  if (logo && getCookie('popupDisplayed') === 'loaded') {
    // Automatically fade the logo after a delay
    setTimeout(() => {
      logo.classList.add('hilang');
    }, 4000);

    // Also fade the logo on the first scroll event
    let scrolledAway = false;
    window.addEventListener('scroll', () => {
      if (!scrolledAway) {
        logo.classList.add('hilang');
        scrolledAway = true;
      }
    });
  }
}


  // Function to get the value of a cookie
  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  // Function to set a cookie with a specific expiration time
  function setCookie(name, value) {
    document.cookie = name + "=" + value + "; " + "expires= 0;" + "; path=/"; // Set the cookie with path attribute
  }

  // Change N/A Option for banner size to Regular
  //TODO wrap with event listener and improve condition check
  let path_last = window.location.pathname.split('/').pop();
  if (path_last == 'layout') {
    function waitForElm(selector) {
      return new Promise(resolve => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }

    waitForElm('.ui-dialog.ui-corner-all.ui-widget.ui-widget-content.ui-front').then((elm) => {

      // Get the label element
      const labelElement = document.querySelector('.horizontal-tabs-panes .form-item-settings-block-form-field-banner-size label');

      // Check if the label element exists
      if (labelElement) {
        // Check if the label text is "N/A"
        if (labelElement.textContent.trim() === 'N/A') {
          // Change the label text to "regular"
          labelElement.textContent = 'Regular';
        }
      }

    });
  }

  // Something to do with curriculum pages?
  //TODO wrap with event listenener and make conditional on being curriculum pages and
  var curriculumTitle = document.querySelector(".curriculum-links .curriculum-links-title");
  var curriculumLists = document.querySelector(".curriculum-links .curriculum-lists");

  if(curriculumTitle){
    curriculumTitle.addEventListener('click', function(){
      curriculumLists.classList.toggle('show');
      curriculumTitle.classList.toggle('active');
    });
  }

  // What's on listing pages stuff
  //TODO wrap with event listenener and make conditional on being whatson page
  // Get the filter element on whats on page
  var filter = document.querySelector('.whats-on-filter');

  // Get the whats-on element
  var whatsOn = document.querySelector('.whats-on');

  var search_filter = document.querySelector('.search-filter h3');
  var search_filter_menu = document.querySelector('.search-filter .search-menu');
  var searchSort = document.querySelector('.search-sort h3');
  var searchSortMenu = document.querySelector('.search-sort .search-menu');

  // Add a click event listener to the filter
  if (searchSort) {
    searchSort.addEventListener('click', function () {
      // Toggle the class "show" on the whats-on element
      searchSortMenu.classList.toggle('show');
      searchSort.classList.toggle('active');
    });
  }

  // Add a click event listener to the filter
  if (search_filter) {
    search_filter.addEventListener('click', function () {
      // Toggle the class "show" on the whats-on element
      search_filter_menu.classList.toggle('show');
      search_filter.classList.toggle('active');
    });
  }

  // Add a click event listener to the filter
  if (filter) {
    filter.addEventListener('click', function () {
      // Toggle the class "show" on the whats-on element
      whatsOn.classList.toggle('show');
      search_filter_menu.classList.toggle('show');
      filter.classList.toggle('active');
      search_filter.classList.toggle('active');
    });
  }

  // Also for search page (?) //TODO make conditional on being search page
  document.addEventListener("DOMContentLoaded", function () {
    // Find all links with the class "see-all-link"
    const seeAllLinks = document.querySelectorAll(".see-all-link");

    // Add a click event listener to each link
    seeAllLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();

        // Get the data-topic attribute to determine the selected topic
        const topic = link.getAttribute("data-topic");

        // Get the current URL search parameters
        const urlSearchParams = new URLSearchParams(window.location.search);

        // Preserve the existing 'items_per_page' parameter
        const itemsPerPage = urlSearchParams.get('items_per_page');

        // Update or add the 'type' parameter with the selected topic
        urlSearchParams.set('type', topic);

        // Restore the 'items_per_page' parameter
        if (itemsPerPage !== null) {
          urlSearchParams.set('items_per_page', itemsPerPage);
        } else {
          // If 'items_per_page' doesn't exist, add it
          urlSearchParams.set('items_per_page', 'All');
        }

        // Construct the new URL with the updated search parameters
        const newURL = `/search?${urlSearchParams.toString()}`;

        // Reload the page with the new URL
        window.location.href = newURL;
      });
    });
  });

  // For search page (?) //TODO make conditional on being search page, and clean/document
  document.addEventListener("DOMContentLoaded", function () {
    // Parse the current URL
    const urlSearchParams = new URLSearchParams(window.location.search);
    const typeParam = urlSearchParams.get('type');
    const elasticSearchDiv = document.querySelector(".view-elastic-search-external-resources");
    const searchNumber = document.getElementById("main-search-results");
    const seeAllLink = document.querySelector(".see-all-link");

    // Find all elements with the class "search-result"
    const searchResultContainers = document.querySelectorAll(".search-result");

    // Check if the 'type' parameter exists in the URL
    if(typeParam){
      if (typeParam === 'All') {
        // If 'type' is 'All', display all search result containers
        searchResultContainers.forEach(function (container) {
          container.style.display = "block"; // Show the container
        });
      } else {
        // Loop through each search result container
        if (elasticSearchDiv) {
          elasticSearchDiv.style.display = "none";
        }
        if(searchNumber){
          searchNumber.style.display = "none";
        }
        if(seeAllLink){
          seeAllLink.style.display = "none";
        }
        // Create an anchor (link) element and set its attributes
        const backButton = $('<a>', {
          class: 'mb-5 border-bottom',
          text: 'View all search results',
          href: 'javascript:history.back();' // JavaScript to navigate back
        });

        // Append the link to the "search-topic-header" div
        $('.search-topic-header').append(backButton);

        searchResultContainers.forEach(function (container) {
          // Check if the container has the class that matches the 'type' parameter
          if (!container.classList.contains(typeParam)) {
            // Hide the search result container
            container.style.display = "none";
          } else {
            // Show the matching search result container
            container.style.display = "block";
          }
        });
      }
    }
  });

  // Secondary nav stuff
  jQuery(document).ready(function($) {
    // Function to check if the screen width is mobile (<= 768px)
    function isMobile() {
      return $(window).width() <= 768;
    }
  
    // Loop through each menu item with a submenu
    $('.secondary-navigation ul.nav.navbar-nav li').each(function() {
      var menuItem = $(this);
      var link = menuItem.children('a');
      var submenu = menuItem.children('ul');
  
      // Initialize click count for each menu item
      menuItem.data('clickCount', 0);
  
      // If the menu item has a submenu
      if (submenu.length > 0) {
        // Hide the submenu only on mobile initially
        if (isMobile()) {
          submenu.hide();
        }
  
        // Attach a click event to the menu item for mobile devices
        menuItem.click(function(event) {
          if (isMobile()) {
            event.stopPropagation(); // Prevent document click event from triggering
            event.preventDefault(); // Prevent default action initially
  
            // Check if the menu item has a link with an href attribute
            if (link.attr('href')) {
              // Get the current click count
              var clickCount = menuItem.data('clickCount');
  
              // First click: Show the submenu
              if (clickCount === 0) {
                submenu.stop(true, true).slideDown(300); // Slide down to show submenu
                link.addClass('chevron-open'); // Add class to rotate the chevron
                closeOtherSubmenus(menuItem); // Close other open submenus
                menuItem.data('clickCount', 1); // Set click count to 1
  
              // Second click: Follow the link if present
              } else if (clickCount === 1) {
                window.location.href = link.attr('href'); // Follow the link
              }
            } else {
              // If no link, just toggle the submenu visibility
              if (submenu.is(':visible')) {
                submenu.stop(true, true).slideUp(300);
                link.removeClass('chevron-open');
              } else {
                submenu.stop(true, true).slideDown(300);
                link.addClass('chevron-open');
                closeOtherSubmenus(menuItem); // Close other open submenus
              }
            }
          }
        });
      }
    });
  
    // Prevent the document click from closing the menu when clicking inside the menu
    $('.secondary-navigation').click(function(event) {
      if (isMobile()) {
        event.stopPropagation(); // Stop the click from propagating to the document
      }
    });
  
    // Close menu or submenus if clicked outside on mobile
    $(document).click(function(event) {
      if (isMobile()) { // Only execute if mobile view
        var target = $(event.target);
  
        // If click is outside the secondary navigation and menubar
        if (!target.closest('.secondary-navigation').length && !target.closest('.menubar').length) {
          closeAllMenus(); // Close all menus and reset states
        }
      }
    });
  
    // Function to close all menus, submenus, and reset states
    function closeAllMenus() {
      $('.secondary-navigation ul.nav.navbar-nav li ul').slideUp(300); // Close all submenus
      $('.secondary-navigation ul.nav.navbar-nav li a').removeClass('chevron-open'); // Reset chevron rotation
      $('.secondary-navigation ul.nav.navbar-nav li').data('clickCount', 0); // Reset click count
  
      // Close the main menu if it's open
      var navMenu = $('.menubar').closest('.menu-links').find('.navbar-nav');
      navMenu.stop(true, true).slideUp(300).removeClass('active');
      $('.menubar').removeClass('active'); // Reset menubar button state
    }
  
    // Function to close other submenus when one is clicked
    function closeOtherSubmenus(activeItem) {
      $('.secondary-navigation ul.nav.navbar-nav li').each(function() {
        var otherItem = $(this);
        if (otherItem[0] !== activeItem[0]) {
          var otherSubmenu = otherItem.children('ul');
          if (otherSubmenu.length > 0) {
            otherSubmenu.stop(true, true).slideUp(300); // Slide up to hide submenu
            otherItem.children('a').removeClass('chevron-open'); // Reset chevron rotation
            otherItem.data('clickCount', 0); // Reset click count
          }
        }
      });
    }
  
    // Toggle visibility for the mobile menu when the menubar button is clicked
    $('.menubar').click(function(event) {
      if (isMobile()) { // Only execute if mobile view
        event.stopPropagation(); // Prevents closing when clicking on the menubar
        $(this).toggleClass('active');
        var navMenu = $(this).closest('.menu-links').find('.navbar-nav');
        if (navMenu.hasClass('active')) {
          closeAllMenus(); // Close all menus if the menubar is active
        } else {
          navMenu.stop(true, true).slideDown(300).addClass('active');
        }
      }
    });
  
    // Reset click counts and submenu visibility on window resize
    $(window).resize(function() {
      if (!isMobile()) {
        $('.secondary-navigation ul.nav.navbar-nav li ul').show();
        $('.secondary-navigation ul.nav.navbar-nav li a').removeClass('chevron-open');
        $('.secondary-navigation ul.nav.navbar-nav li').data('clickCount', 0);
      } else {
        $('.secondary-navigation ul.nav.navbar-nav li ul').hide();
      }
    });
  });
  
  
})(jQuery, Drupal, drupalSettings);
